import type { Me } from "./types";

// Who's signed in, with their menus and permissions, remembered in the browser for the visit (this
// tab, brief 1E-29), so the shell draws at once while /api/me is asked again alongside the
// screen's own data. The server still checks every request; this only draws the menus sooner.
// Signing out (by hand or after idle) drops it.

const KEY = "fc-me";

/** The last /api/me answer this tab had, or null. */
export function keptMe(): Me | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    const me = raw ? (JSON.parse(raw) as Me) : null;
    return me && Array.isArray(me.menus) && me.user?.id ? me : null;
  } catch {
    return null;
  }
}

export function keepMe(me: Me) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(me));
  } catch {
    // Private windows and full storage: the shell waits for /api/me as before.
  }
}

export function dropMe() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing kept.
  }
}
